import Link from "next/link";
import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="rainbow-section-gap">
        <div className="container">
          <div className="rbt-dashboard-content">
            <div className="text-center">
              <div className="content-page pb--30">
                <h3 className="title">Privacy Policy</h3>
              </div>
            </div>
            <div className="content-page pb--50">
              <div className="chat-box-list">
                <div className="content">
                  <h6>  At CyberAgric, we are committed to protecting the privacy and security of our users' personal information. This Privacy Policy outlines how we collect, use, and safeguard the data you provide when using our website and mobile application.</h6>
                   <h4>Information we collect</h4>
                  <ol>
                    <li>
                      Personal Information: When you create an account or contact us, we may collect personal information such as your name, email address, phone number, and physical address.
                    </li>
                    <li>
                      Usage Data: We may collect information about how you use our website and app, including pages visited, features used, and interactions with our services.
                    </li>
                    <li>
                     Device Information: We may collect information about the device you use to access our services, such as the device type, operating system, and unique device identifiers.
                    </li>
                    <li>Location Data: With your consent, we may collect location data from your device to provide location-based services, such as soil analysis or weather information.</li>
                    <li>Image Data: Our app allows you to upload images of crops and soil samples, which are used for disease detection and analysis purposes.</li>
                  </ol>

                  <h4>How We Use Your Information</h4>

                  <ol>
                    {/* <li>
                      We collect certain personal information about visitors and
                      users of our Sites.{" "}
                      <Link href="http://rainbowit.net/themes/imroz">
                        http://rainbowit.net/themes/imroz
                      </Link>
                    </li> */}
                    <li>
                     To provide and improve our services: We use the information we collect to deliver and enhance our AI-powered crop management solutions, including disease diagnosis, soil analysis, and virtual assistance.
                    </li>
                     <li>
                     To communicate with you: We may use your contact information to send updates, notifications, and respond to your inquiries or requests.

                    </li>
                     <li>
                     For analytics and research: We may analyze aggregated and anonymized data to improve our services, develop new features, and conduct research related to agriculture and AI.

                    </li>
                     <li>
                     For legal compliance: We may use your information to comply with applicable laws, regulations, and legal processes.


                    </li>
                    
                  </ol>

                  <h4>Data Security</h4>

                  <ol>
                     <li>
                     We implement reasonable and appropriate technical, physical, and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.
                    </li>
                  
                  </ol>
                  <h4>Data Sharing and Disclosure</h4>

                  <ol>
                     <li>
                     We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website, app, and services. These service providers are bound by confidentiality agreements and are not permitted to use your information for any other purpose.
                    </li>
                  <li>We may also disclose your information when required by law, to protect our rights or the rights of others, or to prevent or investigate potential violations of our terms and conditions.</li>
                  </ol>
                  <h4>Data Retention</h4>

                  <ol>
                     <li>
                     We retain your personal information for as long as necessary to provide our services and comply with legal obligations. We may retain certain anonymized data for analytics and research purposes.

                    </li>
                  </ol>
                   <h4>Your Rights and Choices</h4>

                  <ol>
                     <li>
                    You have the right to access, update, or delete your personal information by contacting us. You can also choose to opt-out of receiving promotional communications from us.

                    </li>
                  </ol>
                   <h4>Updates to this Privacy Policy</h4>

                  <ol>
                     <li>
                     We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. We will notify you of any significant changes and provide an opportunity to review the updated policy.

                    </li>
                  </ol>
                   <h4>Contact Us</h4>

                  <ol>
                     <li>
                      If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
                      <div>
                        Address: 1309 Coffeen Ave STE 1200 Sheridan Wyoming 82801, USA
                        <br />
                        Email: info@cyberagric.com
                      </div>

                    </li>
                  </ol>
                   <h6>By using CyberAgric's website, app, and services, you acknowledge that you have read and understood this Privacy Policy and agree to the collection, use, and disclosure of your information as described herein.</h6>
                    <h6>This comprehensive privacy policy covers the following key aspects:</h6>
                  <ol>
                     <li>
                     Information collected (personal, usage, device, location, and image data)

                    </li>
                    <li>
How the information is used (service provision, communication, analytics, and legal compliance)
                    </li>
                    <li>
                      Data security measures implemented
                    </li>
                    <li>
                      Data sharing and disclosure practices
                    </li>
                    <li>
                      Data retention policies
                    </li>
                    <li>
                      User rights and choices regarding personal information
                    </li>
                    <li>
                      Notification of policy updates
                    </li>
                    <li>
                      Contact information for inquiries and concerns
                    </li>
                    <li>
                      Acknowledgment and agreement to the policy by using CyberAgric's services
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
